import { tokens } from '../../../theme/tokens';
import { AccordionConfig } from '../../../types/accordion';

export const ESPN_ACCORDION_CONFIG: AccordionConfig[] = [
  {
    key: 'match',
    title: 'Información del partido',
    subtitle: 'Equipos, fecha y detalles del encuentro',
    fields: ['title', 'team1', 'team2', 'date', 'day', 'channel', 'tournament'],
    defaultOpen: true,
    color: tokens.colors.brands.blue[200]
  },
  {
    key: 'regions',
    title: 'Horarios por región',
    subtitle: 'Configurar horarios para diferentes zonas',
    fields: ['autoSyncTimes', 'region1', 'time1', 'region2', 'time2', 'region3', 'time3', 'region4', 'time4'],
    defaultOpen: true,
    color: tokens.colors.brands.blue[200],
    layout: 'grid'
  }
];
